import { IPayload } from 'models/Global'
import { IGetPaymentsParams, IPayment } from 'models/Payment'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class PaymentsApi {
  constructor(private axios: AxiosService) {}

  getPayments = async (params?: IGetPaymentsParams) => {
    const response = await this.axios.get<IPayload<IPayment[]>>(Endpoints.getPayments, params)
    return response
  }

  getPayment = async (id: number, params?: IGetPaymentsParams) => {
    const response = await this.axios.get<IPayload<IPayment>>(Endpoints.getPayment(id), params)
    return response
  }

  deletePayment = async (id: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deletePayment(id))
    return response
  }
}
